<!-- 封装modal组件 -->
<template>
  <!-- v-NoScroll="attrs.visible" -->
  <div ref="zc" class="zc" v-NoScroll="attrs.visible">
    <a-modal
      :getContainer="() => $refs.zc"
       v-bind="attrs"
      :maskClosable="maskClosable"
      @ok="handleOk"
      @cancel="cancel"
      :destroyOnClose="true"
    >
    <template #title>
      <slot name="mytitle"></slot>
    </template>
      <slot name="body"> </slot>

      <template #closeIcon>
        <!-- 给自定义组件提供自定义插槽 -->
        <slot name="cuscloseIcon">
          <img src="@/assets/images/systemicon/closegray.png" alt="" />
        </slot>
      </template>
      <template #footer>
        <slot name="myfooter"></slot>
      </template>
    </a-modal>
  </div>
</template>

<script setup>
import { computed, ref, watch, inject } from "vue";
import { useAttrs } from "vue";
const $attrs = useAttrs();
const scroll = inject("scroll");

//二次封装组件,不用再次定义三方组件的props,emits怎么也做到同样的处理?
const attrs = computed(() => {
  return {
    ...$attrs
  }
})
const props = defineProps({
  // title: {},
  // width: {},
  // visible: {},
  // zIndex: {},
  maskClosable: {
    default: false,
  },
});
const emits = defineEmits(["close"]);
// watch(
//   () => props.visible,
//   () => {
//     if (props.visible) {
//       scroll.noScroll();
//     } else {
//       scroll.canScroll();
//     }
//   }
// );

const vNoScroll = (el, binding) => {
  console.log('binding;',binding.value);
  if (binding.value) {
    console.log('sscroll noscroll');
    scroll.noScroll();
  } else {
    console.log('sscroll canscroll');
    scroll.canScroll();
  }
};

function cancel(e) {
  // console.log("cancel",e);
  emits("close", e);
}

function handleOk() {}
</script>
<style lang="scss" scoped>
:deep(.ant-modal) {
  padding: 0;
  color: #fff;
  .ant-modal-content {
    background-color: transparent;
    background-color: #131723;
    button.ant-modal-close {
      width: max-content;
      height: max-content;
      right: .3rem;
      top: .3rem;
      .ant-modal-close-x {
        width: max-content;
        height: max-content;
        line-height: normal;
        // margin-right: 0.31rem;
        @extend %flex-all-center;
      }
    }
    .ant-modal-header {
      color: #fff;
      background-color: transparent;
      padding: 0;
      border-bottom: none;
      .ant-modal-title {
        @extend %flex-all-center;
        height: inherit;
        color: #fff;
      }
    }
    .ant-modal-footer {
      text-align: center;
      padding: 0;
      border-top: none;
    }
    .ant-modal-body {
      padding: 0;
    }
  }
}
</style>
